import { table_config } from "@/components/modals/events-modal/table.config";
import { ITableConfig } from "@/components/table/table.model";

/**
 * The events table, named for the Gen AI dashboard.
 *
 * The shared config calls these "Event type" and "Exposed by", which is right
 * everywhere else: elsewhere a person exposes content. In a Copilot interaction
 * the agent is the actor, so the spec deck names the first two columns
 * "Activity Type" and "AI Agent" and puts the person under "Exposed to".
 *
 * Derived from the shared config rather than restated, so any column added
 * there appears here too — only the two names differ.
 */
const RENAMED: Record<string, string> = {
  eventType: "Activity Type",
  exposedBy: "AI Agent",
};

export const gen_ai_table_config: ITableConfig = {
  ...table_config,
  columns: table_config.columns.map((c) =>
    RENAMED[c.key] ? { ...c, name: RENAMED[c.key] } : c
  ),
};
